import React, { useState } from 'react';
import { showErrorToast, showSuccessToast } from 'components/Toast';
import { Link } from 'react-router-dom';
import BaseInput from 'components/Inputs/BaseInput';
import ExternalHeader from 'components/Navigation/ExternalHeader';
import InputErrorMessage from 'components/InputErrorMessage';
import { LoginIcon } from '@heroicons/react/outline';
import PublicOnlyRoute from 'components/Navigation/PublicOnlyRoute';
import { REQUIRED_RULE } from 'utils/constants';
import SolidButton from 'components/SolidButton';
import { classNames } from 'utils/functions';
import { useAuth } from 'contexts/Auth';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { API_URL } from 'utils/constants';
import axios from 'axios';

export default function RecoverPasswordPage() {
  const {
    register,
    handleSubmit,
    watch,
    control,
    setValue,
    formState: { errors },
  } = useForm();
  const history = useNavigate();
  const auth = useAuth();

  const password = watch('password');
  const [loading, setLoading] = useState(false);
  const [showCompanies, setShowCompanies] = useState(false);
  const [companies, setCompanies] = useState([]);

    const [step, setStep] = useState(1);
    const [userId, setUserId] = useState("");

  const login = async (data: any) => {
    // setLoading(true);
    let result: any = await auth.signin(data.username, data.password);

    if (!result.success) {
      setLoading(false);
      return showErrorToast(result.message);
    }

    if (result.data?.companies) {
      setShowCompanies(true);
      setCompanies(result.data?.companies.map((obj: any) => ({ value: obj.companyId, name: obj.ruc })));
      return showSuccessToast(result.message);
    }
    finishLogin(result);
  };

  const enter = async (data: any) => {
    setLoading(true);
    let result: any = await auth.enter(data.companyId);
    if (!result.success) {
      setLoading(false);
      return showErrorToast(result.message);
    }
    finishLogin(result);
  };

  const finishLogin = (result: any) => {
    showSuccessToast(result.message);
    history(result?.data?.redirect || '/home', { replace: true });
    history(0);
  }
  const buildBaseInput = (
    label: string,
    type: React.HTMLInputTypeAttribute,
    name: string,
    rules: any,
    props: any
  ) => {
    return (
      <BaseInput
        label={label}
        placeholder={`Ingrese su ${label}`}
        type={type}
        name={name}
        register={register}
        errors={errors}
        watch={watch}
        setValue={setValue}
        control={control}
        rules={rules}
        bgClass="bg-gray-100"
        textUppercase={false}
        {...props}
      />
    );
  };

  const validarUsuario = async (data: any) => {
    try {
      const result = await axios.post(`${API_URL}/users/recovery`,
        {
          username: data.username,
        }
      );
      showSuccessToast("Código OTP enviado correctamente");
      if (result.data?.success) {
        setUserId(result.data?.id);
      }
      setStep(2);
    } catch (error: any) {
      console.log(error);
    }
  };

  const validarOTP = async (data: any) => {
    try {
      const result = await axios.post(`${API_URL}/users/recovery-verify`,
        {
          userId: userId,
          otp: data.otp
        }
      );

      if (result.data?.success) {
        setStep(3);
        showSuccessToast(result.data?.message);
      } else {
        showErrorToast(result.data?.message);
      }

    } catch (error: any) {
      console.log(error);
    }
  };

  const confirmasPassword = async (data: any) => {
    try {
      const result = await axios.post(`${API_URL}/users/password-update`,
        {
          userId: userId,
          password: data.password
        }
      );

      if (result.data?.success) {
        showSuccessToast("Contraseña cambiada correctamente");
        history('/login');
      } else {
        showErrorToast(result.data?.message);
      }

    } catch (error: any) {
      console.log(error);
      showErrorToast(error.response.data.message);
    }
  };

  return (
    <PublicOnlyRoute>
      <div className="min-h-full bg-gray-100">
        <ExternalHeader />
        <div className="mx-auto flex flex-col justify-center py-8 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24 ">
          <div className="mx-auto w-full max-w-md">
            <div>
              <h2 className="mt-6 text-3xl font-extrabold text-gray-900">Recuperar contraseña</h2>
            </div>

            <form /* onSubmit={handleSubmit(login)} */ className="mt-8">
              <div className="relative mt-8">
                <div className="absolute inset-0 flex items-center" aria-hidden="true">
                  <div className="w-full border-t border-gray-300" />
                </div>
                <div className="relative flex justify-center text-sm">
                  <span className="bg-gray-100 px-2 text-gray-500">Ingrese sus datos</span>
                </div>
              </div>

              <div className="mt-6">
                {step === 1 && <div className="flex flex-col space-y-4">
                  {buildBaseInput('Usuario', 'text', 'username', REQUIRED_RULE, {})}
                </div>}
                {step === 1 && <div className="mt-6">
                  <>
                    <div className="mt-6">
                      <SolidButton
                        className="w-full"
                        onClick={handleSubmit(validarUsuario)}
                        isLoading={loading}
                      >
                        Confirmar
                      </SolidButton>
                    </div>
                  </>
                </div>}
                 {step === 2 && <div className="flex flex-col space-y-4">
                  {buildBaseInput('OTP', 'number', 'otp', REQUIRED_RULE, {})}
                </div>}
                {step === 2 && <div className="mt-6">
                  <>
                    <div className="mt-6">
                      <SolidButton
                        className="w-full"
                        onClick={handleSubmit(validarOTP)}
                        isLoading={loading}
                      >
                        Confirmar OTP
                      </SolidButton>
                    </div>
                  </>
                </div>}
                 {step === 3 && <div className="flex flex-col space-y-4">
                  {buildBaseInput('Nueva contraseña', 'password', 'password', REQUIRED_RULE, {})}
                </div>}
                {step === 3 && <div className="mt-6">
                  <>
                    <div className="mt-6">
                      <SolidButton
                        className="w-full"
                        onClick={handleSubmit(confirmasPassword)}
                        isLoading={loading}
                      >
                        Confirmar Contraseña
                      </SolidButton>
                    </div>
                  </>
                </div>}
              </div>
            </form>
          </div>
        </div>
      </div>
    </PublicOnlyRoute>
  );
}
